import React, { useRef } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { func, bool, object, string } from 'prop-types';
import IframeConstructor from '../../components/IframeConstructor/IframeConstructor';

const propTypes = {
  open: bool.isRequired,
  toggle: func.isRequired,
  submit: func.isRequired,
  settings: string,
  link: string,
};

const IframeConstructorModal = ({ open, toggle, submit, settings, link }) => {
  const constructor = useRef(null);

  const submitHandler = () => {
    if (constructor && constructor.current) {
      const instance = constructor.current.getWrappedInstance();
      const { settings } = instance.state;
      submit(JSON.stringify(settings));
    }
  };

  return (
    <Modal backdrop="static" isOpen={open} centered className="iframe-constructor-modal">
      <ModalHeader toggle={toggle}>
        <FormattedMessage id="iframe_constructor.title" defaultMessage="Iframe form settings" />
      </ModalHeader>
      <ModalBody>
        <IframeConstructor ref={constructor} settings={settings} link={link}/>
      </ModalBody>
      <ModalFooter className="text-right">
        <Button color="primary" outline type="button" onClick={toggle}>
          <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
        </Button>
        <Button color="primary" type="button" onClick={submitHandler}>
          <FormattedMessage id="main.save" defaultMessage="Save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

IframeConstructorModal.propTypes = propTypes;

export default IframeConstructorModal;
